import React, { Component } from "react";
import { Button, Stack, Tooltip, } from "@mui/material";
import { withTranslation } from 'react-i18next';
import { DataGrid } from "@mui/x-data-grid";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import CommonGridHeader from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { AmountFormat } from "../../../Components/CommonFunctions/CommonFunctions";
import { CurrencySymbol } from "../../../Utility/Constants";
import { ImagePaths } from '../../../Utility/ImagePaths';

class IOLDrugs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            pageSize: 10,
            stockListData: [],
            disableBtn: false,
        }
    }

    componentDidMount = () => {
        this.getStockList()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    getStockList = () => {
        try {
            RestAPIService.getAll(Serviceurls.OT_IOL_STOCK_LIST)
                .then((response) => {
                    if (response.data.status === "Success") {
                        this.setState({
                            stockListData: response.data.data
                        })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    getIolDrugExcel = () => {
        try {
            this.setState({ disableBtn: true });
            RestAPIService.excelGet(`${Serviceurls.OT_IOL_STOCK_LIST}?export_type=excel`)
                .then((response) => {
                    if (response.data) {
                        const pom = document.createElement('a');
                        const csvContent = response.data; //here we load our csv data 

                        const filename = response.headers["content-disposition"].split("filename=")[1]

                        const blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
                        const url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({ disableBtn: false });
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                    this.setState({ disableBtn: false });
                })
        } catch (error) {
            this.setState({ disableBtn: false });
            this.errorMessage(error.message);
        }
    }

    render() {
        this.state.stockListData.forEach((element, index) => { element.sno = index + 1 })
        const { t } = this.props
        const columns = [
            { field: 'sno', headerName: t('SNo'), sortable: false, flex: 0.07, renderCell: (params) => (<div emed_tid={`iol_drugs_sno_cell_${params.row.sno}`}>{params?.row?.sno || '-'}</div>) },
            {
                field: 'brand_name', headerName: t('BrandName'), sortable: false, flex: 0.111,
                renderCell: (params) => (<div emed_tid={`iol_drugs_brand_cell_${params.row.sno}`}>{params?.row?.brand_name?.length > 14 ? <Tooltip placement="top" title={params?.row?.brand_name} arrow emed_tid={`iol_drugs_brand_tooltip_${params.row.sno}`}><div emed_tid={`iol_drugs_brand_truncated_${params.row.sno}`}>{params?.row?.brand_name.slice(0, 14) + "..."}</div></Tooltip> : <div emed_tid={`iol_drugs_brand_full_${params.row.sno}`}>{params?.row?.brand_name}</div>}</div>)
            },
            {
                field: 'model_name', headerName: t('Model Name'), sortable: false, flex: 0.111,
                renderCell: (params) => (<div emed_tid={`iol_drugs_model_cell_${params.row.sno}`}>{params?.row?.model_name?.length > 14 ? <Tooltip placement="top" title={params?.row?.model_name} arrow emed_tid={`iol_drugs_model_tooltip_${params.row.sno}`}><div emed_tid={`iol_drugs_model_truncated_${params.row.sno}`}>{params?.row?.model_name.slice(0, 14) + "..."}</div></Tooltip> : <div emed_tid={`iol_drugs_model_full_${params.row.sno}`}>{params?.row?.model_name}</div>}</div>)
            },
            { field: 'iol_type', headerName: t('IOL Type'), sortable: false, flex: 0.111, renderCell: (params) => (<div emed_tid={`iol_drugs_iol_type_cell_${params.row.sno}`}>{params?.row?.iol_type || '-'}</div>) },
            { field: 'iol_power', headerName: t("IOL Power"), sortable: false, flex: 0.111, type: "number", renderCell: (params) => (<div emed_tid={`iol_drugs_iol_power_cell_${params.row.sno}`}>{params?.row?.iol_power || '-'}</div>) },
            { field: 'batch_number', headerName: t('BatchNumber'), sortable: false, flex: 0.111, type: "number", renderCell: (params) => (<div emed_tid={`iol_drugs_batch_number_cell_${params.row.sno}`}>{params?.row?.batch_number || '-'}</div>) },
            { field: 'stock_in_quantity', headerName: t('Quantity'), sortable: false, flex: 0.111, type: "number", renderCell: (params) => (<div emed_tid={`iol_drugs_quantity_cell_${params.row.sno}`}>{params?.row?.stock_in_quantity || '-'}</div>) },
            {
                field: 'expiry_date', headerName: t('Expiry Date'), sortable: false, flex: 0.121, headerAlign: "center", align: "center",
                renderCell: (params) => (<div emed_tid={`iol_drugs_expiry_date_cell_${params.row.sno}`}>{params?.row?.expiry_date ? params?.row?.expiry_date : "-"}</div>)
            },
            {
                field: 'physical_box_number', headerName: t('Box'), sortable: false, flex: 0.111, type: "number",
                renderCell: (params) => (<div emed_tid={`iol_drugs_box_cell_${params.row.sno}`}>{params?.row?.physical_box_number ? params?.row?.physical_box_number : "-"}</div>)
            },
            { field: 'mrp_price_per_qty', headerName: t('MRP/Quantity') + ` (${CurrencySymbol})`, sortable: false, flex: 0.111, type: "number",
            renderCell: (params) => (<div emed_tid={`iol_drugs_mrp_cell_${params.row.sno}`}>{AmountFormat(params?.row?.mrp_price_per_qty || 0)?.replace(`${CurrencySymbol}`, "")}</div>) }]
        return (
            <div className="stock_card" emed_tid="iol_drugs_container">
                <div emed_tid="iol_drugs_content">
                    <div role={'button'} className="active_tab_header_card" emed_tid="iol_drugs_header">
                        <Button variant="contained" className="checkbox" onClick={() => { this.props.history.push({ pathname: "/OTInventory/NewIOL"}) }} emed_tid="iol_drugs_new_iol_btn">
                            {t("+ NEW IOL")}
                        </Button>

                        <Tooltip title="Export" placement='top' arrow emed_tid="iol_drugs_export_tooltip">
                            <Button emed_tid="iol_drugs_export_btn" className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn} onClick={() => this.getIolDrugExcel()}>
                                <img src={ImagePaths.ExportIcon.default} alt='export' className='eMed_action_img' emed_tid="iol_drugs_export_icon" />
                            </Button>
                        </Tooltip>

                    </div>
                    <div className="stock_table_container" emed_tid="iol_drugs_table_container">
                        <DataGrid
                            rows={this.state.stockListData}
                            rowCount={this.state.total}
                            page={this.state.page}
                            columns={columns}
                            hideFooterSelectedRowCount
                            getRowId={(row) => row['sno']}
                            pageSize={this.state.pageSize}
                            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                            rowsPerPageOptions={[10, 20, 30]}
                            disableSelectionOnClick
                            pagination
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            headerHeight={40}
                            components={{
                                Toolbar: CommonGridHeader.CommonToolBar,
                                NoRowsOverlay: () => (
                                    <Stack height="100%" alignItems="center" justifyContent="center" emed_tid="iol_drugs_no_records">
                                        {t("NoRecordsFound")}
                                    </Stack>
                                )
                            }}
                            emed_tid="iol_drugs_datagrid"
                        />
                    </div>
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                            emed_tid="iol_drugs_error_toast"
                        />
                        : null}
                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                            emed_tid="iol_drugs_success_toast"
                        />
                        : null}
                </div>
            </div>
        )
    }
}
export default withTranslation()(IOLDrugs);